<template>
  <ToolCard
    :tool="enrichedTool"
    class="chat-tool-suggestion"
  />
</template>

<script>
import ToolCard from '../../ToolCard.vue';

export default {
  name: 'ToolSuggestionCard',
  components: {
    ToolCard,
  },
  props: {
    tool: {
      type: Object,
      required: true,
      // Enhanced format: { id, name, description, score, explanation, use_case, location, url }
      // Also supports legacy format and image_url and comments
    },
  },
  computed: {
    enrichedTool() {
      // Map tool suggestion data to ToolCard expected format
      return {
        // Core fields
        id: this.tool.id || this.tool.tool_id,
        name: this.tool.name || `Tool #${this.tool.tool_id}`,
        description: this.tool.description || this.tool.explanation || '',
        score: this.tool.score || 0,
        
        // Enhanced fields
        use_case: this.tool.use_case,
        location: this.tool.location,
        url: this.tool.url,
        image_url: this.tool.image_url,
        
        // Build comments from explanation and other details
        comments: this.buildComments(),
      };
    },
  },
  methods: {
    buildComments() {
      const parts = [];
      
      // Add explanation if it exists and differs from description
      if (this.tool.explanation && this.tool.explanation !== this.tool.description) {
        parts.push(`${this.tool.explanation}`);
      }
      
      return parts.length > 0 ? parts.join('\n\n') : undefined;
    },
  },
};
</script>

<style scoped lang="scss">
.chat-tool-suggestion {
}
</style>
